import type { ReactNode } from "react";
import { cn } from "@lumika/ui";

const SIZES = {
  sm: "h-7 w-7 text-[10px]",
  md: "h-8 w-8 text-[11px]",
  lg: "h-16 w-16 text-xl",
} as const;

interface ContactAvatarProps {
  name: string;
  avatarUrl?: string | null;
  size?: keyof typeof SIZES;
  className?: string;
  badge?: ReactNode;
}

export function ContactAvatar({
  name,
  avatarUrl,
  size = "md",
  className,
  badge,
}: ContactAvatarProps) {
  return (
    <span className={cn("relative inline-flex shrink-0", className)}>
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt={name}
          className={cn("shrink-0 rounded-full object-cover", SIZES[size])}
        />
      ) : (
        <span
          className={cn(
            "flex shrink-0 items-center justify-center rounded-full bg-primary/15 font-bold uppercase text-primary",
            SIZES[size],
          )}
          aria-label={name}
        >
          {initialsOf(name)}
        </span>
      )}
      {badge ? (
        <span className="absolute -bottom-1 -right-1 flex">{badge}</span>
      ) : null}
    </span>
  );
}

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
}
